module.exports = __webpack_public_path__ + "static/media/img_3.4ada9e9e.jpg";